import List from '../../containers/Orders/List';
import Edit from '../../containers/Orders/Edit';
import Create from '../../containers/Orders/Create';
import Show from '../../containers/Orders/Show';

export default { List, Edit, Create, Show };
